import type { IEnv } from './environment.interface';

export const environment: IEnv = {
  "name": "dev",
  "aws": {
    "auth": {
      "region": "eu-west-1",
      "userPoolId": "eu-west-1_nVWn3tR4j",
      "userPoolWebClientId": "53re42g45dhlh5l8rd8fcf77ku",
      "oauth": {
        "domain": "mymaintenance-dev.auth.eu-west-1.amazoncognito.com",
        "scopes": [
          "openid"
        ],
        "redirectSignIn": [
          "https://mymaintenance-dev.faktory.digital"
        ],
        "redirectSignOut": [
          "https://mymaintenance-dev.faktory.digital"
        ],
        "responseType": "code",
        "providers": [
          {
            "custom": "mymaintenancgnitoentraId2A147976"
          }
        ]
      }
    }
  },
  "api": "https://52zcdgyadi.execute-api.eu-west-1.amazonaws.com/dev/",
  "pollingInterval": 5000
};
